import { inject } from 'tsyringe'
import Vue from 'vue'
import { containerScoped } from '~/decorators/dependency-container'
import { comparableRootCategoryIds } from '~/constants/compare'
import { CategoryId } from '~/models/category/types'
import { NamespacedStore } from '~/models/store/types'
import LoggerService from '~/services/LoggerService'
import CompareService from '~/services/compare/CompareService'
import {
  ClassifiedViewState,
  CLASSIFIED_VIEW_NS
} from '~/store/modules/shared/classifieds/view/state'
import { StoreWithRootState } from '~/store/types'
import { getNamespacedStore } from '~/utils/store'
import { storeToken } from '~/constants/dependency-injection/tokens'

@containerScoped()
export default class CompareViewService {
  private viewStore: NamespacedStore<ClassifiedViewState>
  constructor(
    @inject(CompareService) private compareService: CompareService,
    @inject(LoggerService) private logger: LoggerService,
    @inject(storeToken) store: StoreWithRootState
  ) {
    this.viewStore = getNamespacedStore(store, CLASSIFIED_VIEW_NS)
  }

  async addViewClassifiedToCompare(
    viewComponentInstance: Vue,
    refName: string,
    isMobileView: boolean = false
  ) {
    const classifiedId = this.viewStore.state.classifiedId

    if (!classifiedId) {
      return
    }

    try {
      await this.compareService.setComparedClassified(
        this.getViewClassifiedCategoryId(),
        classifiedId
      )
      if (isMobileView) {
        const mobileCompareButtonRef =
          // @ts-ignore
          viewComponentInstance.$refs.viewMobileInfo.$refs[refName]
        if (mobileCompareButtonRef) {
          mobileCompareButtonRef.displayPopover(classifiedId)
        }
      } else {
        const utilButtonsRef =
          // @ts-ignore
          viewComponentInstance.$refs?.utilButtons?.$refs?.[refName]
        if (utilButtonsRef) {
          utilButtonsRef.displayPopover(classifiedId)
        } else {
          // @ts-ignore
          viewComponentInstance.$refs[refName].displayPopover(classifiedId)
        }
      }
    } catch (error) {
      this.logger.captureError(error)
    }
  }

  getViewClassifiedCategoryId(): CategoryId {
    const { classified } = this.viewStore.state
    return comparableRootCategoryIds.find((c: any) =>
      classified?.category_ids.includes(c)
    )!
  }
}
